import React from 'react'

import styled from 'styled-components'

import { Spinner } from '../../components/Spinner'

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
`

const Loading: React.SFC = () => (
  <>
    <Container>
      <Spinner />
    </Container>
  </>
)

export { Loading }
